import {IReportConfigurationAttribute} from 'store/slices/report-configuration-slice';
import {IReportConfigurationReportColumnDto} from 'store/slices/report-configuration-slice/report-configuration-dto';
import {TReportConfigurationConvertedField} from 'store/slices/report-configuration-slice/report-configuration-types';

export const convertAttributes = (
    attributes: IReportConfigurationAttribute[],
    reportColumns: TReportConfigurationConvertedField<IReportConfigurationReportColumnDto>,
) => {
    if (!attributes) {
        return [];
    }

    return attributes
        .map(({
            name, type, typeGroup, comment,
        }) => {
            const title = reportColumns?.find(
                (column: any) => column?.keyName === name,
            )?.reportTitle;

            return {
                label: title ?? name,
                value: name,
                type: type ?? 'Тип не найден',
                typeGroup,
                name,
                comment,
            };
        });
};
